// Note: Would love to switch to an opensource alternative of Google Analytics,
//       but no alternative I've found is free (e.g. Fathom, Plausible)

export default {
  gaTrackingCode: process.env.REACT_APP_GA_TRACKING_CODE,
};
